import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Link from 'gatsby-link';

import Heading from '@marvelapp/marvel-ui/heading';
import MarvelLink from '@marvelapp/marvel-ui/link';
import Paragraph from '@marvelapp/marvel-ui/paragraph';

import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck';

import iconStyles from './style/icon.module.css';
import backgroundStyles from './style/background.module.css';
import generalStyles from './style/general.module.css';

const cx = classNames.bind({ ...backgroundStyles, ...iconStyles });

const bgValues = [
  'marvel',
  'green',
  'teal',
  'yellow',
  'orange',
  'pink',
  'purple',
  'red',
];

export default function Quote({
  boldContent,
  caption,
  content,
  headingSize,
  icon,
  iconColor,
  isLight,
  linkText,
  linkUrl,
  tag,
}) {
  const headingProps = {
    tag,
    weight: 'regular',
    size: headingSize,
    color: isLight ? 'white' : 'black',
  };
  const iconClassName = cx('icon', iconColor);
  const Icon = icon;
  const iconProps = {
    className: iconClassName,
    style: {
      width: '40px',
      height: '40px',
    },
  };

  return (
    <figure>
      {icon &&
        (iconColor ? (
          <div {...iconProps}>
            <Icon />
          </div>
        ) : (
          <Icon />
        ))}
      <blockquote className={generalStyles.heading}>
        <Heading {...headingProps}>
          {boldContent && <span className="fontWeight-6">{boldContent}</span>}{' '}
          {content}
        </Heading>
      </blockquote>
      {caption && (
        <figcaption className={generalStyles.caption}>
          <Paragraph color={isLight ? 'smoke' : 'slate'} size="m">
            {caption}{' '}
            {linkText && (
              <Link to={linkUrl}>
                <MarvelLink type={isLight ? 'blue' : 'blue'}>
                  <span className="fontWeight-5">{linkText}</span>
                </MarvelLink>
              </Link>
            )}
          </Paragraph>
        </figcaption>
      )}
    </figure>
  );
}

Quote.propTypes = {
  boldContent: PropTypes.string,
  caption: PropTypes.string,
  content: propTypeEmptyString,
  headingSize: PropTypes.oneOf(['xxl', 'xxxl', 'xxxxl']),
  icon: PropTypes.func,
  iconColor: PropTypes.oneOf(bgValues),
  isLight: PropTypes.bool,
  linkText: PropTypes.string,
  linkUrl: PropTypes.string,
  tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5']),
};

Quote.defaultProps = {
  isLight: false,
  headingSize: 'xxl',
  tag: 'h3',
};



// WEBPACK FOOTER //
// ./src/components/modules/Quote/index.js